export const formatAIResponse = (text) => {
  if (!text) return "";

  let formatted = text;

  // =========================
  // 🔥 Escape HTML (security)
  // =========================
  formatted = formatted
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");

  // =========================
  // 🔥 HEADINGS + SPACING
  // =========================
  formatted = formatted
    .replace(/^### (.*)$/gm, "<h3 style='margin-top:16px;margin-bottom:8px'>$1</h3>")
    .replace(/^## (.*)$/gm, "<h2 style='margin-top:20px;margin-bottom:10px'>$1</h2>")
    .replace(/^# (.*)$/gm, "<h1 style='margin-top:24px;margin-bottom:12px'>$1</h1>");

  // =========================
  // 🔥 BOLD + ITALIC
  // =========================
  formatted = formatted
    .replace(/\*\*(.*?)\*\*/g, "<b>$1</b>")
    .replace(/\*(.*?)\*/g, "<i>$1</i>");

  // =========================
  // 🔥 LIST ITEMS
  // =========================
  formatted = formatted
    .replace(/^\*\s(.+)$/gm, "<li>$1</li>")
    .replace(/^\d+\.\s(.+)$/gm, "<li>$1</li>");

  // wrap lists properly
  formatted = formatted.replace(/(<li>.*?<\/li>)/gs, "<ul style='margin:8px 0;padding-left:20px'>$1</ul>");

  // =========================
  // 🔥 CODE BLOCKS
  // =========================
  formatted = formatted.replace(
    /```([\s\S]*?)```/g,
    "<pre style='background:#111;color:#0f0;padding:10px;border-radius:6px;overflow:auto;margin:10px 0'><code>$1</code></pre>"
  );

  // inline code
  formatted = formatted.replace(
    /`([^`]*)`/g,
    "<code style='background:#eee;padding:2px 4px;border-radius:4px'>$1</code>"
  );

  // =========================
  // 🔥 PARAGRAPH SPACING
  // =========================
  formatted = formatted
    .split("\n\n")
    .map(p => `<p style="margin:10px 0;line-height:1.6">${p}</p>`)
    .join("");

  // =========================
  // 🔥 CLEAN LINE BREAKS
  // =========================
  formatted = formatted.replace(/\n/g, "<br/>");

  return formatted;
};